<template>
  <div v-if="isClosed" ref="toggleChild" @click="emitClick()">
    <a
      :href="href"
      :class="{
        'tw-pointer-events-none': disabled,
      }"
      @click="navigate"
      ><li
        class="tw-flex tw-w-60 tw-cursor-pointer tw-justify-between tw-p-4 hover:tw-bg-primary-grey-400"
        :class="[
          isActive
            ? 'tw-bg-primary-grey-400 tw-px-4 tw-font-bold tw-transition-all'
            : 'tw-bg-primary-grey-600',
          disabled && 'tw-text-primary-grey-200',
          hasDescendants && 'tw-pl-8',
          hasActiveDescendants && 'tw-bg-primary-grey-600 tw-shadow-none',
        ]"
        :data-test-id="`${dataTestId}-closed`"
      >
        {{ label }}
        <ClIconTablerChevronDown
          v-if="needsToggle"
          class="tw-transition-transform"
          :class="isOpen ? 'tw-rotate-180' : 'tw-rotate-0'"
        /></li
    ></a>
  </div>
  <div v-if="!isClosed" ref="toggleChild" @click="emitClick()">
    <a
      :href="href"
      :class="{
        'tw-pointer-events-none': disabled,
      }"
      @click="navigate"
      ><li
        class="tw-flex tw-w-full tw-cursor-pointer tw-justify-between tw-p-4 hover:tw-bg-primary-grey-400"
        :class="[
          isActive
            ? 'tw-bg-primary-grey-400 tw-px-4 tw-font-bold tw-shadow-[inset_0.1875rem_0] tw-shadow-white tw-transition-all'
            : '',
          disabled && 'tw-text-primary-grey-200',
          hasActiveDescendants && 'tw-shadow-none',
        ]"
        :data-test-id="`${dataTestId}-open`"
      >
        <div class="tw-flex tw-w-full tw-justify-between">
          <span :class="hasDescendants ? 'tw-pl-[75px] ' : 'tw-pl-10'">
            {{ label }}
          </span>
          <span>
            <slot name="pill" />
          </span>
        </div>
        <ClIconTablerChevronDown
          v-if="needsToggle"
          class="tw-transition-transform"
          :class="isOpen ? 'tw-rotate-180' : 'tw-rotate-0'"
        /></li
    ></a>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";

import { ClIconTablerChevronDown } from "../icons";

interface NavItemProps {
  label: string;
  isClosed: boolean;
  navigate: (payload: MouseEvent) => void;
  href: string;
  isActive: boolean;
  dataTestId?: string;
  disabled?: boolean;
  needsToggle?: boolean;
  hasDescendants: boolean;
  hasActiveDescendants?: boolean;
}
const isOpen = ref(false);

withDefaults(defineProps<NavItemProps>(), {
  isActive: false,
  dataTestId: "child-subnav",
  disabled: false,
  needsToggle: false,
  hasDescendants: false,
  hasActiveDescendants: false,
});
const toggleChild = ref(null);

onClickOutside(toggleChild, () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
});
const emit = defineEmits<{
  (event: "on-click", val: boolean): void;
}>();
const emitClick = (): void => {
  if (!isOpen.value) {
    isOpen.value = true;
  }
  emit("on-click", isOpen.value);
};
</script>
